export default {
    CPF: 1,
    NIS: 2,
    NOME_MAE: 3,
    TITULO_ELEITOR: 4,
}